import React from "react";
import "./jobRoleDetailsTree.css";
export default function Tile({ item, onSelect, jobRoleDetails, field }) {
  return (
    <div
      key={item.id}
      className={`tile  col-2 m-1  text-center ${
        Number(jobRoleDetails[field]) === item.id ? "active" : ""
      }`}
      onClick={() => onSelect(item)}
    >
      <p>{item.description}</p>
    </div>
  );
}
